class ChangePasswordController {
	/*@ngInject*/
	constructor($translate, UsersService, Modal, $scope, User) {
		this.$translate = $translate
		this.UsersService = UsersService
		this.Modal = Modal
		this.User = User
		this.model = {
			userId: '',
			password: null,
			cnfPassword: null,
			passwordPolicy: null
		};
		this.errorMessage = null;
		this.passIcon = {
			pass: false,
			cpass: false
		}
	}
	focusElementById(id) {
		setTimeout(() => {
			document.getElementById(id).focus();
		}, 300)
	}

	$onInit() {
		this.focusElementById(this.modelDetails.isWebPassword ? 'password' : 'read_password');
	}

	changePassword() {
		this.loading = true;
		const passwordKey = this.modelDetails.isWebPassword ? 'password' : 'hhtPassword',
			savedata = {
				id: this.modelDetails.id,
				[passwordKey]: this.model.password || null,
			};

		this.UsersService.update(this.modelDetails.id, savedata)
			.then((data) => {
				if (data.error) return this.Modal.errorModal(data.error);
				this.onConfirm(this.modelDetails.id, data);
			})
			.catch((err) => {
				console.log(err);
				if (err && err.data && err.data.message) return this.Modal.errorModal(err.data.message);
				else return this.onError(err)
			})
			.finally(() => {
				this.loading = false;
			})
	}

	showPassword(type) {
		this.passIcon[type] = !this.passIcon[type];
	}

	changeWebPassword() {
		this.UsersService.changeWebPassword(this.User.getUser().id, this.User.getUser().branchId, this.modelDetails.id, this.model.password)
			.then((data) => {
				this.loading = false;
				if (data && data.message == 'failed') {
					this.model.passwordPolicy = data;
					this.model.password = null;
					this.model.cnfPassword = null;
					return;
				}
				else {
					this.model.passwordPolicy = null;
				}
				this.onConfirm(this.modelDetails.id, data);
			})
			.catch((err) => {
				console.log(err);
				if (err && err.data && err.data.message) {
					return this.Modal.errorModal(err.data.message);
				}
			})
	}
}
export default ChangePasswordController;


// WEBPACK FOOTER //
// ./client/app/common/ui/changePassword/changePassword.controller.js